import Box from '@mui/material/Box/Box'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchRationComponents } from '../../store/rationSystemSlice'
import { COLORS } from '../../styles/colors'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'
import RationTableComponents from './RationTableComponents'

const RationsFullComponents = () => {
	const dispatch = useAppDispatch()
	useEffect(() => {
		dispatch(fetchRationComponents())
	}, [dispatch])
	const { rationComponents, loading, error } = useAppSelector(
		state => state.rationSystemReducer,
	)
	if (loading) {
		return (
			<Box
				sx={{
					marginTop: '25%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<CircularProgress
					sx={{
						'&.MuiCircularProgress-colorPrimary': { color: COLORS.main },
					}}
				/>
			</Box>
		)
	} else if (error) {
		;<>{error}</>
	}
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			<TypographySecondary sx={{ marginTop: '8px' }}>
				Всего компонентов: {rationComponents?.length}
			</TypographySecondary>
			<RationTableComponents rationComponents={rationComponents} />
		</Box>
	)
}

export default RationsFullComponents
